<template>
  <v-dialog :value="value" @input="$emit('input', $event)" max-width="600px">
    <v-card>
      <v-card-title>
        <span class="headline">{{ $t('MENU.CONTACT_US') }}</span>
        <v-spacer/>
        <tk-btn icon @click="$emit('input', !value)">
          <v-icon>fas fa-times</v-icon>
        </tk-btn>
      </v-card-title>

      <v-card-text>
        <p v-html="$t('COMMON.TERMS_DISAGREE_DESC')"></p>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: ["value"]
};
</script>

